module.exports = __webpack_public_path__ + "static/media/37.ee3ac69e.JPG";